import { slideUp, slideDown } from 'theme-utilities';

const getBannerStorage = () => {
	const storageItem = sessionStorage.getItem(sessionStorageKey);
	return storageItem !== null ? JSON.parse(storageItem) : [];
};

const setBannerStorage = (data) => sessionStorage.setItem(sessionStorageKey, JSON.stringify(data));

const selectors = {
	banner: '.banner',
	bannerClose: '.banner__close',
};

const sessionStorageKey = 'mcfly_hidden_banners';
const hiddenBanners = getBannerStorage();
const slideDuration = 250;

window.addEventListener('load', () => {
	document.querySelectorAll(selectors.banner).forEach((banner) => {
		// Show banner if banner has not been closed a previous time
		if (!hiddenBanners.includes(banner.id)) {
			slideDown(banner, slideDuration);
		}
	});
});

// Close banner on click
document.querySelectorAll(selectors.bannerClose).forEach((close) => {
	close.addEventListener('click', () => {
		// Close banner
		const banner = close.closest(selectors.banner);
		slideUp(banner, slideDuration);

		// Update storage
		const hiddenBanners = getBannerStorage();
		hiddenBanners.push(banner.id);
		setBannerStorage(hiddenBanners);
	});
});
